import * as React from 'react';
export var NewbuildingMvkContext = /*#__PURE__*/React.createContext({
  logger: {},
  httpApi: {}
});